import { useTranslation } from 'react-i18next';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import { colors } from '../../styles/GlobalStyles';
import { Icon, IconDownload } from '../../styles/Icons';
import { H3, P2 } from '../../styles/FontStyles';
import { Flexed, PageTitle } from '../../styles/GlobalComponents';
import { Resource, ResourcesContainer } from './ResourcesStyled';
import resourcesImage1 from '../../assets/images/resource-image-1.png';
import resourcesImage2 from '../../assets/images/resource-image-2.png';
import resourcesImage3 from '../../assets/images/resource-image-3.png';

export const Resources = () => {
  const { t } = useTranslation('resources');
  return (
    <AnimatedDashboard zoom dark key='resources'>
      <PageTitle mt='0' color={colors.primary900}>
        {t('resources')}
      </PageTitle>
      <Flexed rowSM mb='20' gap='20px'>
        <Flexed width='50%' widthSM='100%'>
          <img src={resourcesImage1} alt='resources' width='100%' />
        </Flexed>
        <Flexed width='50%' widthSM='100%'>
          <img src={resourcesImage2} alt='resources' width='100%' />
        </Flexed>
      </Flexed>
      <Flexed rowSM gap='20px'>
        <Flexed width='50%' widthSM='100%'>
          <ResourcesContainer>
            <H3 semiBold color={colors.primary900}>
              PDF
            </H3>

            <Resource
              href='https://resources.unitedone.global/presentations/compensation-plan.pdf'
              target='_blank'
              rel='noreferrer'>
              <P2>Compensation Plan</P2>
              <Icon>
                <IconDownload />
              </Icon>
            </Resource>
            <Resource
              href='https://resources.unitedone.global/presentations/business-presentation.pdf'
              target='_blank'
              rel='noreferrer'>
              <P2>Business Presentation</P2>
              <Icon>
                <IconDownload />
              </Icon>
            </Resource>
          </ResourcesContainer>
        </Flexed>
        <Flexed width='50%' widthSM='100%'>
          <img src={resourcesImage3} alt='resources' width='100%' />
        </Flexed>
      </Flexed>
    </AnimatedDashboard>
  );
};
